.player-poster[data-poster] {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 998;
  top: 0;
  left: 0;
  background-color: transparent;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;

  &.clickable { cursor: pointer; }
  &:hover .play-wrapper[data-poster] { opacity: 1; }

  .play-wrapper[data-poster] {
    width: 100%;
    height: 25%;
    margin: 0 auto;
    opacity: 0.75;
    transition: opacity 0.1s ease;
    svg {
      height: 100%;
      path { fill: #fff; }
    }
  }
}
